import React, { useCallback } from 'react';
import styled from 'styled-components';
import ButtonImage from "../../assets/marker.png";
const Button = styled.button`
    background: transparent;
    border: none;
    width: 20px;
    height: 28px;
    padding: 0px;
    margin-left: 25px;
    &:active {
        position: relative;
	    top: 2px;
    }
`;
const Img = styled.img`
    height: 100%;
    width: auto;
`;
type Props = {
    onClick: () => void;
}
const PlaybackPositionSaveButton: React.FC<Props> = ({onClick}) => {
    const handleClick = useCallback(() => {
        onClick();
    }, [onClick]);
    return (
        <Button onClick={handleClick}>
            <Img src={ButtonImage}/>
        </Button>
    );
};
export default PlaybackPositionSaveButton;
